import React from "react";

import { useStyles } from "./checkpoint-layout.styles";

interface Props {
  class_name?: string;
  has_indent?: boolean;
  slot_start?: React.ReactNode;
  slot_middle?: React.ReactNode;
  slot_end?: React.ReactNode;
}

export const CheckpointLayout: React.FC<Props> = ({
  class_name,
  has_indent = true,
  slot_start,
  slot_middle,
  slot_end
}) => {
  const { cx, classes } = useStyles();

  return (
    <div className={cx(classes.container, class_name)}>
      {!!slot_start && <div className={classes.slotStart}>{slot_start}</div>}
      {!!slot_middle && <div className={classes.slotMiddle}>{slot_middle}</div>}
      {!!slot_end && (
        <div
          className={cx(classes.slotEnd, {
            [classes.hasIndent]: has_indent
          })}
        >
          {slot_end}
        </div>
      )}
    </div>
  );
};
